import Loadable from 'react-loadable';
import Loading from 'skd-ui/Loading/Loading';

export default Loadable({
	loader: () => import(/* webpackChunkName: 'Api'*/ 'src/controllers/Api/Api'),
	loading: Loading,
});
